module.exports = __webpack_public_path__ + "img/googlePlay.e23c5ef9.jpeg";